import React, { useState, useRef, useEffect } from 'react';
import { useForm } from "react-hook-form";
import * as sessionActions from "../../store/session";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useLocation, useSearchParams, Link as RouterLink } from "react-router-dom";
import {
  Box,
  Container,
  CssBaseline,
  Grid,
  Typography,
  Button,
  Link,
} from '@mui/material';
import { Home } from '@mui/icons-material';
import { ThemeProvider, styled } from '@mui/material/styles';
import PromotionDialog from '../../PromotionDialog';
import theme from '../../theme';

const StyledGClientLoginButton = styled((props) => (
  <Button {...props}/>
))(({ theme }) => ({
  '&:hover': {
    backgroundColor: '#25529E',
  },
}));

const StyledGUserLoginButton = styled((props) => (
  <Button {...props}/>
))(({ theme }) => ({
  '&:hover': {
    backgroundColor: '#E83E35',
  },
}));

const GLogin = () => {

  const [openPromotion, setOpenPromotion] = useState(false);

  const location = useLocation();

  const sessionUser = useSelector((state) => state.session.sessionUser);

  useEffect(() => {
    const hideUntil = localStorage.getItem('promotionHideUntil');
    if (hideUntil) {
      const hideDate = new Date(hideUntil);
      const now = new Date();
      if (now < hideDate) {
        return;
      }
    }
    // setOpenPromotion(true); // 프로모션 추가 : 기간 만료로 주석처리
  }, []);

  // 로그인되어 있다면 이 페이지가 뜨지 않고 root로 이동시킴
  if (sessionUser) {
    console.log("LoginFormPage/index sessionUser exists.");
    console.log(location);
    return <Navigate to={location.state && location.state.from ? `${location.state.from}` : "/glass/dashboard"} />; // TODO : state 필요없는지 확인 필요
  } else {
    console.log("LoginFormPage/index no sessionUser exists.");
  }

  return (
    <ThemeProvider theme={theme}>
      <Container component="main" maxWidth="sm" sx={{ pt: { xs: 0, mobile: undefined } }}>
        <CssBaseline />
        <Box
          sx={{
            marginTop: { xs: 1, sm: 6 },
            marginBottom: -4,
            minHeight: 'calc(100vh - 186px)', 
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Grid container spacing={5}>
            <Grid item xs={12} display="flex" justifyContent={"center"} alignItems={"center"}>
              <Typography component="h1" variant="h5" sx={{ color: '#777'}}>{"회원사 관리자 또는 사용자로 로그인합니다."}</Typography>
            </Grid>
            <Grid item xs={12} sm={6} display="flex" justifyContent={"center"} alignItems={"center"}>
              <Box sx={{ width: '100%', height: { xs: '80px', mobile: '200px' } }}>
                <StyledGClientLoginButton component={RouterLink} to="/glass/signin/gclient" variant="contained" sx={{ width: '100%', height: '100%', fontSize: '1.4rem', fontWeight: 'bold', bgcolor: '#3372B7' }}>
                  {"관리자"}
                </StyledGClientLoginButton>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} display="flex" justifyContent={"center"} alignItems={"center"}>
              <Box sx={{ width: '100%', height: { xs: '80px', mobile: '200px' } }}>
                <StyledGUserLoginButton component={RouterLink} to="/glass/signin/guser" variant="contained" sx={{ width: '100%', height: '100%', fontSize: '1.4rem', fontWeight: 'bold', bgcolor: '#F59036' }}>
                  {"사용자"}
                </StyledGUserLoginButton>
              </Box>
            </Grid>
            <Grid item xs={12} display="flex" justifyContent={"center"} alignItems={"center"}>
              <Link href={"/"}><Button sx={{ mt: 3, mb: 2, fontSize: "1.2rem" }} startIcon={<Home />}>{"홈으로"}</Button></Link>
            </Grid>
          </Grid>
        </Box>
      </Container>
      <PromotionDialog open={openPromotion} setOpen={setOpenPromotion} />
    </ThemeProvider>
  );
}

export default GLogin;